module.exports = __webpack_public_path__ + "fonts/Arsenal-Bold.55b0cc8d.ttf";